import {
  PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_FAIL,
  PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_REQUEST,
  PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_RESET,
  PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_SUCCESS,
  PAYMENT_TENANT_SETUP_INTENT_REQUEST,
  PAYMENT_TENANT_SETUP_INTENT_RESET,
  PAYMENT_TENANT_SETUP_INTENT_SUCCESS,
  PAYMENT_TENANT_SETUP_INTENT_FAIL,
  PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_REQUEST,
  PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_SUCCESS,
  PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_FAIL,
  PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_RESET,
  PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_REQUEST,
  PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_SUCCESS,
  PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_FAIL,
  PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_RESET,
  PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_REQUEST,
  PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_SUCCESS,
  PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_FAIL,
  PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_RESET,
  PAYMENT_TENANT_REMOVE_ALL_TAXIDS_REQUEST,
  PAYMENT_TENANT_REMOVE_ALL_TAXIDS_SUCCESS,
  PAYMENT_TENANT_REMOVE_ALL_TAXIDS_FAIL,
  PAYMENT_TENANT_REMOVE_ALL_TAXIDS_RESET,
  PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_REQUEST,
  PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_SUCCESS,
  PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_FAIL,
  PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_RESET,
  PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_REQUEST,
  PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_SUCCESS,
  PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_FAIL,
  PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_RESET,
  PAYMENT_TENANT_CANCEL_SUBSCRIPTION_REQUEST,
  PAYMENT_TENANT_CANCEL_SUBSCRIPTION_SUCCESS,
  PAYMENT_TENANT_CANCEL_SUBSCRIPTION_FAIL,
  PAYMENT_TENANT_CANCEL_SUBSCRIPTION_RESET,
  PAYMENT_TENANT_GET_MODULES_REQUEST,
  PAYMENT_TENANT_GET_MODULES_SUCCESS,
  PAYMENT_TENANT_GET_MODULES_FAIL,
  PAYMENT_TENANT_GET_MODULES_RESET,
} from "../constants/paymentConstants";

export const paymentTenantCreateSubscriptionAutoTaxReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_SUCCESS:
      return {
        loading: false,
        success: true,
        clientSecret: action.payload.clientSecret,
        invoice: action.payload.invoice,
        subscriptionId: action.payload.subscriptionId,
      };

    case PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentTenantSetupIntentReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYMENT_TENANT_SETUP_INTENT_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_SETUP_INTENT_SUCCESS:
      return {
        loading: false,
        success: true,
        clientSecret: action.payload.clientSecret,
      };
    case PAYMENT_TENANT_SETUP_INTENT_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_SETUP_INTENT_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentTenantGetStripeBillingDetailsReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_SUCCESS:
      return {
        loading: false,
        success: true,
        tenantBillingDetails: action.payload,
      };
    case PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentTenantCheckUpdateVatCodeReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_SUCCESS:
      return {
        loading: false,
        success: true,
        vatCheckDetails: action.payload,
      };
    case PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_FAIL:
      return {
        loading: false,
        error: action.payload.message,
        vatCheckDetails: action.payload,
      };
    case PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentTenantUpdateAddressCreateSubscriptionReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_SUCCESS:
      return {
        loading: false,
        success: true,
        clientSecret: action.payload.clientSecret,
        invoice: action.payload.invoice,
      };
    case PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentTenantRemoveAllTaxIdsReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYMENT_TENANT_REMOVE_ALL_TAXIDS_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_REMOVE_ALL_TAXIDS_SUCCESS:
      return { loading: false, success: true };
    case PAYMENT_TENANT_REMOVE_ALL_TAXIDS_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_REMOVE_ALL_TAXIDS_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentTenantGetStripePaymentMethodsReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_SUCCESS:
      return {
        loading: false,
        success: true,
        tenantPaymentMethods: action.payload,
      };
    case PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentUpdateSubscriptionBillingAndCreateCheckoutReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_REQUEST:
      return { loading: true };

    case PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_SUCCESS:
      return {
        loading: false,
        success: true,
        checkoutUrl: action.payload.checkoutUrl, // ✅ Stores the Stripe Checkout URL
      };

    case PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_FAIL:
      return { loading: false, error: action.payload };

    case PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_RESET:
      return {};

    default:
      return state;
  }
};

export const paymentTenantCancelSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYMENT_TENANT_CANCEL_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_CANCEL_SUBSCRIPTION_SUCCESS:
      return { loading: false, success: true };
    case PAYMENT_TENANT_CANCEL_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_CANCEL_SUBSCRIPTION_RESET:
      return {};
    default:
      return state;
  }
};

export const paymentTenantGetModulesReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYMENT_TENANT_GET_MODULES_REQUEST:
      return { loading: true };
    case PAYMENT_TENANT_GET_MODULES_SUCCESS:
      return {
        loading: false,
        success: true,
        modules: action.payload,
      };
    case PAYMENT_TENANT_GET_MODULES_FAIL:
      return { loading: false, error: action.payload };
    case PAYMENT_TENANT_GET_MODULES_RESET:
      return {};
    default:
      return state;
  }
};
